export default __webpack_public_path__ + "static/media/SPECTRA-RETRACTABLE-ROOF-GOA.213f1b38.jpg";